import React, { useState, useEffect, useContext, useRef } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { StockInInnerStyle, StockInHeaderDetailsStyle, StockInItemListStyle } from './css/StockInInnerStyle'
import { ContentInner } from '../../layout/Content'
import AutoCompleteList from '../../layout/AutoCompleteList'
import { filterItemsSearch, formatNumber } from '../../utilities/utilities'
import { stockInControllerContext } from './StockInController'
import ModalWindow from '../../layout/modalwindow/ModalWindow'

function StockInHeaderDetails() {
  const dateReceivedRef = useRef()
  const stockInController = useContext(stockInControllerContext)
  const [stockIn, setStockIn] = stockInController.stockIn
  const { stockInList, warehouses } = stockInController
  const [activeInput, setActiveInput] = useState('')
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [currentStockInList, setCurrentStockInList] = useState([])

  useEffect(() => {
    if (activeInput)
      if (currentStockInList.length > 0)
        ReactDOM.render(
          <AutoCompleteList
            valueSetter={(value) => setStockIn({ ...stockIn, [activeInput]: value })}
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={currentStockInList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    if (itemClicked) {
      setItemClicked(false)
      setCurrentStockInList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockIn.received_by, stockIn.supplier_name, stockIn.remarks, keyPressed, itemClicked])

  const onChange = (e) => {
    const itemName = ['received_by', 'supplier_name', 'remarks']

    // Avoid unwanted character
    if (!keyPressed) return

    setStockIn({ ...stockIn, [e.target.name]: e.target.value })

    // If the item is not on the array then return
    if (!itemName.find(item => item === e.target.name)) return

    setActiveInput(e.target.name)

    const filteredItemList = filterItemsSearch(stockInList.map(item => item[e.target.name]), e.target.value)
    setCurrentStockInList(filteredItemList)
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        if (e.target.name !== 'reference_code') {
          setCurrentStockInList([])
          ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        }
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const onRemarksInputFocus = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  useEffect(() => {
    const showMessageBox = () => {
      const onClick = () => {
        setStockIn({...stockIn, remarks: ''})
        document.getElementById('remarks').focus()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header='StockIn Remarks Invalid'
          footer={null}
          height='25'
          width='35'>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>'so-auto-transfer' as remarks is not allowed.</div>
              <br/>
              <div>Please select a different remarks title.</div>
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (stockIn.remarks === 'so-auto-transfer') { showMessageBox() }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockIn.remarks])

  return (
    <React.Fragment>
      <div id='stock-in-form-container'>
        <div id='add-new-stock-header'>Add New Stocks</div>
        <hr />
        <div className='stock-in-form' id='destination-warehouse-container'>
          <label htmlFor='warehouse'>Destination Warehouse</label>
          <div className='input-container'>
            <select
              id='warehouse'
              name='warehouse'
              value={stockIn.warehouse.name}
              onChange={(e) => setStockIn({
                ...stockIn,
                warehouse: {
                  name: e.target.value,
                  id: warehouses.find(wh => wh.name === e.target.value)._id
                }
              })}>
              {
                (warehouses) ?
                  warehouses.map(warehouse => (
                    <option key={warehouse._id} style={{fontSize: '1rem'}}>{warehouse.name}</option>
                  ))
                : null
              }
            </select>
          </div>
        </div>
        <div className='stock-in-form' id='date-received-container'>
          <label htmlFor='date-received'>Date Received*</label>
          <div className='input-container'>
            <input
              ref={dateReceivedRef}
              type='date'
              id='date-received'
              name='date_received'
              placeholder='date received'
              value={stockIn.date_received}
              onChange={(e) => setStockIn({ ...stockIn, date_received: e.target.value})} />
          </div>
              {/* value={stockIn.date_received} */}
        </div>
        <div className='stock-in-form' id='received-by-container'>
          <label htmlFor='received-by'>Received By*</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='received_by'
              name='received_by'
              placeholder='received by'
              value={stockIn.received_by}
              onKeyDown={onKeyDown}
              onChange={onChange}/>
            <div id='received_by-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='stock-in-form' id='supplier-container'>
          <label htmlFor='supplier-name'>Supplier Name*</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='supplier_name'
              name='supplier_name'
              placeholder='supplier name'
              value={stockIn.supplier_name}
              onKeyDown={onKeyDown}
              onChange={onChange}/>
            <div id='supplier_name-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='stock-in-form' id='reference-code-container'>
          <label htmlFor='reference-code'>Reference</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='reference_code'
              name='reference_code'
              placeholder='reference code'
              onKeyDown={onKeyDown}
              value={stockIn.reference_code}
              onChange={onChange}/>
          </div>
        </div>
        <div className='stock-in-form' id='stock-in-new-remarks-container'>
          <label htmlFor='stock-in-new-remarks'>Remarks</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='remarks'
              name='remarks'
              placeholder='remarks'
              value={stockIn.remarks}
              onKeyDown={onKeyDown}
              onFocus={onRemarksInputFocus}
              onChange={onChange}/>
            <div id='remarks-acl-container' className='acl-container'></div>
          </div>
        </div>
      </div>
      <StockInHeaderDetailsStyle />
    </React.Fragment>
  )
}

function StockInItemList() {
  const stockInItemDetailNameRef = useRef(null)
  const stockInController = useContext(stockInControllerContext)
  const [stockIn, setStockIn] = stockInController.stockIn
  const [stockInItemDetail, setStockInItemDetail, resetStockInItemDetail] = stockInController.stockInItemDetail
  const { productsList, summary } = stockInController
  const [itemUnitDescriptionList, setItemUnitDescriptionList] = useState([])
  const [currentProductsList, setCurrentProductsList] = useState([])
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [currentItem, setCurrentItem] = useState(null)
  const [currentItemIndex, setCurrentItemIndex] = useState(null)
  const [editMode, setEditMode] = useState(null)
  const [editButtonClick, setEditButtonClick] = useState(false)
  const [itemOK, setItemOK] = useState(null)
  const [currentUnitIsFractional, setCurrentUnitIsFractional] = useState(null)

  const onChange = (e) => {
    // Avoid unwanted characters to prevent regular expressions error on filter
    if (!keyPressed) return

    setStockInItemDetail({ ...stockInItemDetail, name: e.target.value })
    const filteredItemList = filterItemsSearch(productsList.map(product => product.item_full_description), e.target.value)
    setCurrentProductsList(filteredItemList)
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setCurrentProductsList([])
        ReactDOM.unmountComponentAtNode(document.getElementById('name-acl-container'))
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const highlightItemDetailsRow = (itemIndex, highlight=false) => {
    const itemDetailsRow = document.getElementById(itemIndex+'item-details-row')
    if (highlight) itemDetailsRow.classList.add('highlight-item-details-row')
    else itemDetailsRow.classList.remove('highlight-item-details-row')
  }

  const onClickStockInAddItem = async (e) => {
    if (currentItemIndex !== null) { // It's on edit mode

      stockIn.item_details[currentItemIndex] = stockInItemDetail

      setCurrentItemIndex(null)
      highlightItemDetailsRow(currentItemIndex, false)
    } else setStockIn({ ...stockIn, item_details: [...stockIn.item_details, stockInItemDetail] })

    // Resets
    resetStockInItemDetail()
    setCurrentItem(null)

    await stockInItemDetailNameRef.current.focus()
    await stockInItemDetailNameRef.current.scrollIntoView()

    setEditMode(false)
  }

  const onClickDDButton = (e) => {
    const dd_menu = e.target.closest('.dd-menu')
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })

    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    action_btn_menu.classList.toggle('show-dd-menu')
  }

  const onDDFocus = (e) => {
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })
  }

  const onClickStockInEditItem = (e) => {
    // Hide pop-up action button
    const dd_menu = e.target.closest('.dd-menu')
    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    if (action_btn_menu.classList.contains('show-dd-menu'))
      action_btn_menu.classList.remove('show-dd-menu')

    const itemIndex = parseInt(e.target.id)
    setCurrentItemIndex(itemIndex)
    setStockInItemDetail(stockIn.item_details[itemIndex])

    // Highlight the stock in item detail being edited
    highlightItemDetailsRow(itemIndex, true)

    // Disable the elipse button
    setEditMode(true)
    setEditButtonClick(true)

    stockInItemDetailNameRef.current.focus()
    stockInItemDetailNameRef.current.scrollIntoView()
  }

  const onClickStockInDeleteItem = (e) => {
    const itemIndex = parseInt(e.target.id)
    setStockIn({ ...stockIn, item_details: stockIn.item_details.filter((item, index) => itemIndex !== index) })

    stockInItemDetailNameRef.current.focus()
    stockInItemDetailNameRef.current.scrollIntoView()
  }

  const onFocusItemNameInput = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  useEffect(() => {
    if (currentProductsList.length > 0)
      ReactDOM.render(
        <AutoCompleteList
          valueSetter={(value) => setStockInItemDetail({ ...stockInItemDetail, name: value })}
          keyPressed={keyPressed}
          setItemClicked={setItemClicked}
          items={currentProductsList}
        />, document.getElementById('name-acl-container')
      )
    else
      ReactDOM.unmountComponentAtNode(document.getElementById('name-acl-container'))

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    if (itemClicked) {
      setItemClicked(false)
      setCurrentProductsList([])
    }

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockInItemDetail.name, keyPressed, itemClicked])

  useEffect(() => {
    // Check if the item_full_description is found
    const item = (
      productsList
      .find((product) => ( product.item_full_description.toLowerCase() === stockInItemDetail.name.toLowerCase()))
    )

    setCurrentItem(item)

    if (item) {
      setItemUnitDescriptionList(item.item_units.map(item => item.description))
      setStockInItemDetail({
        ...stockInItemDetail,
        id: item.item_id,
        unit: (editButtonClick) ? stockInItemDetail.unit : item.item_units.map(item => item.description)[0]
      })
    } else setItemUnitDescriptionList([])

    if (!editButtonClick) stockInItemDetail.expiration_date = ''

    setEditButtonClick(false)
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockInItemDetail.name])

  useEffect(() => {
    if (currentItem && stockInItemDetail.id) {
      const fractional = currentItem.item_units.find(item => item.description === stockInItemDetail.unit)
      setCurrentUnitIsFractional(fractional.fractional)

      const current_unit = currentItem.item_units.find(item_unit => item_unit.description === stockInItemDetail.unit)
      setStockInItemDetail({
        ...stockInItemDetail,
        fob: current_unit.capital_amount,
        total: (current_unit.capital_amount * stockInItemDetail.quantity)
      })
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockInItemDetail.unit, currentItem])

  useEffect(() => {
    setItemOK(currentItem && (stockInItemDetail.quantity > 0))
    if (currentItem) {
      const current_unit = currentItem.item_units.find(item_unit => item_unit.description === stockInItemDetail.unit)
      setStockInItemDetail({
        ...stockInItemDetail,
        fob: current_unit.capital_amount,
        total: (current_unit.capital_amount * stockInItemDetail.quantity)
      })
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockInItemDetail.quantity, currentItem])

  return (
    <React.Fragment>
      <div id='item-unit-quantity-container'>
        <table className="table-item-unit-details striped-table">
          <thead>
            <tr className='table-header'>
              <th>#</th>
              <th>Item</th>
              <th>Unit</th>
              <th style={{textAlign: 'center'}}>Quantity</th>
              <th style={{textAlign: 'center'}}>FOB</th>
              <th style={{textAlign: 'center'}}>Total</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>
          {
            stockIn.item_details.map((item, index) => (
              <tbody key={item.id+index}>
                <tr id={index+'item-details-row'}>
                  <td>{index + 1}</td>
                  <td className='item-name-container'>
                    <div className='item-name'>{item.name}</div>
                    <div
                      style={{display: (item.expiration_date) ? 'block' : 'none'}}
                      className='expiration-date-container'>
                      Expiration Date:&nbsp; <span className='expiration-date'>{item.expiration_date}</span>
                    </div>
                  </td>
                  <td>{item.unit}</td>
                  <td style={{textAlign: 'center'}}>{item.quantity}</td>
                  <td style={{textAlign: 'right'}}>{formatNumber(item.fob)}</td>
                  <td style={{textAlign: 'right'}}>{formatNumber(item.total)}</td>
                  <td>{item.remarks}</td>
                  <th>
                    <div key={index} className='dd-menu'>
                      <button
                        id={index+'action-row-btn'}
                        onClick={onClickDDButton}
                        onFocus={onDDFocus}
                        className={editMode ? 'pospro-action-btn ellips-btn disabled-button' : 'pospro-action-btn ellips-btn'}
                        disabled={editMode}>
                        <FontAwesomeIcon icon='ellipsis-v'/>
                      </button>
                      <div className='action-btn-menu'>
                        <button
                          id={index+'edit-row-btn'}
                          onClick={onClickStockInEditItem}
                          className="pospro-action-btn edit-row-btn">
                          e
                        </button>
                        <button
                          id={index+'del-row-btn'}
                          onClick={onClickStockInDeleteItem}
                          className="pospro-action-btn del-row-btn">
                          &times;
                        </button>
                      </div>
                    </div>
                  </th>
                </tr>
              </tbody>
            ))
          }
          {
            (summary) ?
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{textAlign: 'center', fontWeight: 'bold'}}>Total</td>
                  <td style={{textAlign: 'right', fontWeight: 'bold'}}>{formatNumber(summary.totalTotal)}</td>
                </tr>
              </tbody>
            : null
          }
          <thead>
            <tr>
              <th></th>
              <th>
                <div className='input-container'>
                  <input
                    ref={stockInItemDetailNameRef}
                    className={(currentItem || stockInItemDetail.name === '') ? '' : 'not-found'}
                    autoComplete='off'
                    placeholder='search in [brand] [name] [description]'
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    onFocus={onFocusItemNameInput}
                    value={stockInItemDetail.name}
                  />
                  <div id='name-acl-container' className='acl-container'></div>
                </div>
              </th>
              <th>
                <select
                  id="item-unit"
                  onChange={(e) => { setStockInItemDetail({...stockInItemDetail, unit: e.target.value}) } }
                  value={stockInItemDetail.unit}>
                  {
                    itemUnitDescriptionList.map((unit, i) => (
                      <option key={i}>{unit}</option>
                      )
                    )
                  }
                </select>
              </th>
              <th>
                <input
                  style={{textAlign: 'center'}}
                  id='item-quantity'
                  type='number'
                  min='1'
                  onBlur={(e) => (!e.target.value)
                    ? setStockInItemDetail({...stockInItemDetail, quantity: 1})
                    : (parseInt(e.target.value) < 1)
                      ? setStockInItemDetail({...stockInItemDetail, quantity: 1})
                      : null}
                  onChange={(e) => setStockInItemDetail({
                    ...stockInItemDetail,
                    quantity: (e.target.value)
                    ? currentUnitIsFractional ? parseFloat(e.target.value) : parseInt(e.target.value)
                    : ''
                  })}
                  value={stockInItemDetail.quantity}
                />
              </th>
              <th>
                <input
                  style={{textAlign: 'right'}}
                  id='item-unit-price'
                  readOnly={true}
                  value={formatNumber(stockInItemDetail.fob)}
                />
              </th>
              <th>
                <input
                  style={{textAlign: 'right'}}
                  id='item-unit-total'
                  readOnly={true}
                  value={ (!isNaN(stockInItemDetail.total)) ? formatNumber(stockInItemDetail.total) : 0.00 }
                />
              </th>
              <th>
                <input
                  id='item-remarks'
                  onChange={(e) => setStockInItemDetail({...stockInItemDetail, remarks: e.target.value})}
                  value={stockInItemDetail.remarks}
                />
              </th>
              <th>
                <button
                  id='stock-in-add-item'
                  className={ itemOK ? 'pospro-action-btn' : 'pospro-action-btn disabled-button' }
                  disabled={!itemOK}
                  onClick={onClickStockInAddItem}>
                  <FontAwesomeIcon icon='plus'/>
                </button>
              </th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div className='expiration-date-input-container'>
                  <label>Expiration Date:</label>
                  <input
                    id='stock-in-expiration-data'
                    type='date'
                    value={stockInItemDetail.expiration_date}
                    onChange={(e) => setStockInItemDetail({...stockInItemDetail, expiration_date: e.target.value})}
                  />
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <StockInItemListStyle />
    </React.Fragment>
  )
}

function StockInInner() {
  return (
    <ContentInner>
      <div id='stock-in-container'>
        <StockInHeaderDetails />
        <StockInItemList />
      </div>
      <StockInInnerStyle />
    </ContentInner>
  )
}

export default React.memo(StockInInner)